import { render, staticRenderFns } from "./SchoolNavigation.vue?vue&type=template&id=1bd32a48&"
import script from "./SchoolNavigation.vue?vue&type=script&lang=js&"
export * from "./SchoolNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports